import React from 'react';

export default () => <div>Wylogowany</div>